<template lang="pug">
  .search-cont(@click="$emit('click')")
    .s-cont
      vm-icon(icon="search-outline" color="rgb(156, 156, 156)" size="1rem")
      .text {{ searchText }}
    // vm-icon(icon="close-outline" color="rgb(156, 156, 156)" size="1.2rem" style="opacity: 1;")
</template>

<script>
export default {
  name: 'search-projects',
  props: {
    searchText: {
      type: String,
      default: 'Search Projects...'
    }
  },
  data: () => ({}),
  methods: {}
}
</script>

<style lang="scss" scoped>
.search-cont {
  background: #f3f3f3;
  width: 350px;
  height: 40px;
  border-radius: 10px;
  padding: 0 15px;
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s all ease-in-out;
  &:hover {
    background: #e7e7e7;
  }
  .s-cont {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s all ease-in-out;
    .text {
      width: 100%;
      color: rgb(156, 156, 156);
      margin-left: 8px;
    }
  }
}
@media only screen and (min-width: 1930px) {
  .search-cont {
    width: 30vw !important;
    height: 3vh !important;
    padding: 0 15px;
    .s-cont {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.3s all ease-in-out;
      .text {
        width: 100%;
        font-size: 1.5vw !important;
        color: rgb(156, 156, 156);
        margin-left: 8px;
      }
    }
  }
}
</style>
